import React, { useState } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import MailIcon from '@mui/icons-material/Mail';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import styles from './LandingPageV4.module.css';
import { ToastifyAlert } from '../../Constants/ToastifyAlert';
import { BASE_URL_SANDBOX, NEWSLETTER_SUBSCRIBE } from '../../Constants/Config';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      ToastifyAlert('Please enter a valid email address.', 'error');
      setIsSubmitting(false);
      return;
    }

    const formData = new FormData();
    formData.append('email', email);

    try {
      const response = await axios.post(
        `${BASE_URL_SANDBOX}${NEWSLETTER_SUBSCRIBE}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      const resData = response.data;
      if (resData.status === 'Success') {
        ToastifyAlert(resData.msg, 'success');
        setEmail('');
      } else {
        ToastifyAlert(resData.msg, 'error');
      }
    } catch (err) {
      if (err.response?.status === 409) {
        ToastifyAlert('This email is already subscribed.', 'error');
      } else {
        ToastifyAlert('Subscription failed. Please try again later.', 'error');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className={styles.newsletter} aria-labelledby="newsletter-title">
      <div className={styles.innerWrapper}>
        <div className={styles.newsletterCard}>
          <div className={styles.newsletterIntro}>
            <span className={styles.newsletterIcon}>
              <AutoAwesomeIcon sx={{ fontSize: 20 }} aria-hidden="true" />
            </span>
            <div>
              <h2 id="newsletter-title" className={styles.newsletterTitle}>
                The good stuff, delivered.
              </h2>
              <p className={styles.newsletterSubtitle}>
                Local deals, new drops, and nearby shop updates—only when they
                are worth opening.
              </p>
            </div>
          </div>
          <form onSubmit={handleSubmit} className={styles.newsletterSignup}>
            <div className={styles.newsletterFormWrapper}>
              <div className={styles.newsletterForm}>
                <label htmlFor="newsletter-email" className={styles.visuallyHidden}>
                  Email address
                </label>
                <span className={styles.newsletterInputIcon}>
                  <MailIcon sx={{ fontSize: 18 }} aria-hidden="true" />
                </span>
                <input
                  id="newsletter-email"
                  type="email"
                  placeholder="Email address"
                  className={styles.newsletterInput}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
                <button
                  type="submit"
                  className={styles.newsletterBtn}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <CircularProgress size={16} color="inherit" />
                      <span className={styles.visuallyHidden}>Subscribing</span>
                    </>
                  ) : (
                    'Subscribe'
                  )}
                </button>
              </div>
            </div>
            <p className={styles.newsletterTerms}>
              For adults 21+. By subscribing, you agree to our{' '}
              <a href="/terms-condition">Terms</a> and{' '}
              <a href="/privacy-policy">Privacy Policy</a>.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
